import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const hasTimezoneOffset = (value?: string) => value?.match(/[+-][0-2][0-9]:[0-5][0-9]$/);

export const formatTime = (value?: string, format = 'HH:mm') => {
  const parsedTime = dayjs(value, ['HH:mm:ss', 'HH:mm:ss.SSSZ']);

  if (!parsedTime.isValid()) {
    if (!process.env.CI) {
      console.error(`error: formatTime: Incorrect time: ${value}`);
    }
    return value;
  }

  const timeWithoutTimezone = hasTimezoneOffset(value) ? value?.substring(0, value?.length - 6) : value;
  const parsedTimeWithoutTimezone = dayjs(timeWithoutTimezone, ['HH:mm:ss.SSS', 'HH:mm:ss']);

  if (!parsedTimeWithoutTimezone.isValid()) {
    if (!process.env.CI) {
      console.error(`error: formatTime: Incorrect time: ${value}`);
    }
    return value;
  }

  return parsedTimeWithoutTimezone.format(format);
};
